// @ts-strict-ignore
import { DataTypes } from '~/analytics/journey-analytics/dashboard/filters/filtersConfiguration';

import DetailedOptionLabel from './DetailedOptionLabel';
import type { Props as DropdownFacetProps } from './DropdownFacet';


type Props = {
  facet: DropdownFacetProps['facet'];
  filterType: string | boolean;
  textProps: any;
  values: string[];
  wrapperProps: any;
};

export default function DropdownToggleLabel({
  facet,
  filterType,
  textProps,
  values,
  wrapperProps,
}: Props) {
  if (facet.filter_type === DataTypes.Range) {
    if (![facet.min, facet.max].some(val => [null, undefined].includes(val))) {
      return <span>{facet.min} - {facet.max}</span>;
    }

    return <span>{facet.lowerBound} - {facet.upperBound}</span>;
  }

  if (facet.multivalue && values.length !== 1) {
    return (
      <span>
        {`${filterType === 'filter' ? 'All' : 'Any'} of ${values.length}`}
      </span>
    );
  }

  if (![undefined, null].includes(values[0])) {
    return (
      <DetailedOptionLabel
        facet={facet}
        textProps={textProps}
        value={values[0]}
        wrapperProps={wrapperProps}
      />
    );
  }

  return <span>{facet.dropdown_label.label}</span>;
}
